import { api, createCancelTokenHandler } from "../utils/services";
import { ENV } from "../constants";

const OverviewRepository = {
  all: function () {
    return api.get(`${ENV.getApiEndPoint()}/api/overview`, {
      cancelToken:
        cancelTokenHandlerObject[this.all.name].handleRequestCancellation()
          .token,
    });
  },
};

const cancelTokenHandlerObject = createCancelTokenHandler(OverviewRepository);

export default OverviewRepository;
